import React, { useState } from 'react';
import { useAppSelector } from 'hooks';
import { Collapse, Input } from 'reactstrap';
import dayjs from 'dayjs';

import { Button } from '~components';
import { DateInput } from '~components/form-fields/inputs';
import Icon, { faMagnifyingGlass } from '~components/icon';
import Select from '~components/Select';

import { selectCareWorkerOptions } from '~care-workers/selectors/users';
import { selectClientsOptions } from '~main/selectors/clients/clients';

interface ComponentProps {
  isOpen: boolean;
  weekStart: string;
  setFilters: any;
}

interface Filters {
  client_id: number | null;
  user_id: number | null;
  suburb: string | null;
  date: string | null;
}

const Search: React.FC<ComponentProps> = ({ isOpen, weekStart, setFilters }) => {
  const [formValues, setFormValues] = useState<Filters>({
    client_id: null,
    user_id: null,
    suburb: null,
    date: null,
  });

  const workerOptions = useAppSelector(selectCareWorkerOptions);
  const clientOptions = useAppSelector(selectClientsOptions);
  const weekStartFormat = dayjs(weekStart);
  const weekEndFormat = dayjs(weekStart).add(6, 'day');

  const onSearch = () => {
    setFilters(formValues);
  };

  const handleChange = (name: string, value: string | number | null) => {
    if (!value) {
      setFormValues({ ...formValues, [name]: null });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  return (
    <Collapse isOpen={isOpen} className="search-collapse">
      <div className="search-body">
        <p className="search-title">Search Unallocated Appointments</p>
        <div className="search-row  ">
          <div className="search-field">
            <Select
              label="Client:"
              isClearable
              id="client_id"
              name="client_id"
              options={clientOptions}
              classNamePrefix="select"
              placeholder="Client Name"
              onChange={handleChange}
            />
          </div>
          <div className="search-field">
            <Select
              label="Repeat Worker:"
              isClearable
              id="user_id"
              name="user_id"
              options={workerOptions}
              classNamePrefix="select"
              placeholder="Worker"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="search-row">
          <div className="search-field">
            <p className="my-1">Suburb:</p>
            <Input
              type="text"
              placeholder="Suburb"
              value={formValues.suburb || ''}
              onChange={(e) => handleChange('suburb', e.target.value)}
              bsSize="sm"
            />
          </div>
          <div className="search-field">
            <p className="my-1">Date:</p>
            <DateInput
              id="date"
              type="date"
              name="date"
              minDate={weekStartFormat}
              maxDate={weekEndFormat}
              value={formValues.date}
              onChange={(_, val) => handleChange('date', val)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <Button size="sm" className="search-button" onClick={onSearch}>
            <Icon icon={faMagnifyingGlass} />
            Search
          </Button>
        </div>
      </div>
    </Collapse>
  );
};

export default Search;
